import guid from "guid";

export const spacing = {
  FULL: ["100%", "100%", "100%", "100%"],
  WIDE: ["80%", "80%", "90%", "90%"],
  MEDIUM: ["80%", "80%", "80%", "80%"],
};

export const getMonth = (month: number) => {
  const months = [
    "janúar",
    "febrúar",
    "mars",
    "apríl",
    "maí",
    "júní",
    "júlí",
    "ágúst",
    "september",
    "október",
    "nóvember",
    "desember",
    "desember", //Month 13 exists in data.  Means whole year. Will map to decemeber - should generally not occur on pop-up - there should generally be a new partial year in the DB.
  ];

  return months[month - 1]; //Return the index in the month name enumeration that corresponds with month number.
};

/* 22.08.2025 Getting rid of year hardcoding - use max db year or fall back to real current date.
export const getMaxYear = () => {
  //config.maxYear;
  // if maxYear is null return current real year else return maxYear
  return config.maxYear ? Number(config.maxYear) : new Date().getFullYear();
}
*/

export const getAuthHeader = (accessToken) => {
  // Function to append Bearer against the Access Token
  return "Bearer ".concat(accessToken);
};
